export default __webpack_public_path__ + "static/media/lot_icon.3ef8acc5.svg";